export const URLS = {
  CUSTOMER_PROFILE_URL: `CustomerProfile`,
  NEAREST_WAREHOUSE_URL: `GetNearestBranch`,
  WAREHOUSE_INFO_URL: `GetBranchInfo`,
  GET_ALL_BRANCHES_ORDERED_BY_LOCATION_URL: `GetAllWarehousesOrderedByLocation`,
  GET_ALL_BRANCHES: `GetAllBranches`,
  SET_SELECTED_WAREHOUSE: `SetSelectedWarehouse`,
  VALIDATE_WAREHOUSE_CHANGE: "ValidateWarehouseChange",
  GET_SORTED_CATEGORIES: `GetSortedCategories`,
  GET_PRODUCT_DETAILS: `products`,
  GET_VARIANT_DETAILS: "details",
  GET_HEX_TO_COLOR_MAPPING: "GetHexToColorMapping",
  GET_FEATURED_CATEGORIES: "GetFeaturedCategories",
  GET_SHIP_TOS: "GetShipTos",
  VALIDATE_SHIP_TO_CHANGE: "ValidateShipToChange",
  SET_SELECTED_SHIP_TO: "SetSelectedShipTo",
  GET_SECONDARY_USER_INFO: "GetSecondaryUserInfo",
  GET_MINI_SHOPPING_CART: "GetMiniShoppingCart",
  UPDATE_MINI_CART_ITEM_QUANTITY: "UpdateMiniCartItemQty",
  DELETE_MINI_CART_ITEM: "DeleteMiniCartItem",
  GET_FEATURED_CATEGORIES_VISIBILITIES: "GetFeaturedCategoriesVisibilities",
  GET_BRANCH_DETAILS: "GetBranchDetails",
  GET_STATE_BRANCHES: "GetStateBranches",
  GET_OVERALL_BRANCHES: "GetOverallBranches",
  ORDERS: "orders",
  ORDERS_HISTORY: "orders/history",
  ORDERS_HISTORY_STATUS_COUNT: "orders/history/status-count",
  ORDERS_FILTER_LOOKUP: "orders/filter-lookup",
  CART_ITEMS: "cart/items",
  REPORTS: "reports",
  DELIVERY: "delivery",
  EXCEL: "excel",
  DQ: "dq",
  DELIVERY_ORDER: "delivery-order",
  GET_GOOGLE_Analytics_SETTINGS: "GoogleAnalytic",
  ATTACHMENT: "attachment",
  ATTACHMENTS: "attachments",
  EAGLEVIEW_DOCUMENT: "eagleview-document",
  LOYALTY: "loyalty",
};
